module.exports = __webpack_public_path__ + "img/money-transfer.fe347fbb.svg";